var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom",staticStyle:{"min-width":"1600px"},attrs:{"id":"pcBottom"}},[_c('p',[_vm._v("Copyright © "+_vm._s(_vm.year)+" 上海帆扬宇亿科技有限公司 AII rights reserved")]),_c('p',[_vm._v(" 沪ICP备2024062463号-2 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }